import React, { cloneElement, Component, isValidElement } from 'react';
import { Text, View, Animated, StyleSheet, Dimensions, Platform, TouchableOpacity, PanResponder, BackHandler } from 'react-native';
import Theme, { ThemeColor, Icon } from '@qnpm/q-theme';
import { Portal } from '@qnpm/q-portal';
import { commonUtil, statusBarUtil } from '@qnpm/q-design-utils';
const { font } = Theme;
const isAndroid = Platform.OS === 'android';
const { height: screenHeight } = Dimensions.get('window');
export class RNGestureFloat extends Component {
    constructor(props) {
        super(props);
        this.contentHeight = screenHeight;
        this.scrollOffset = 0;
        this.touchStart = 0;
        this.moveYOffset = 0;
        this.hasCallFunc = false;
        // 暴露给外部不关闭浮层的方法
        this.hideFloat = () => this.onHide();
        /**
         * 头部渲染完成后获取可滚动区域外的高度
         * @param event
         */
        this.onHeaderLayout = (event) => {
            const { headerHeight = 0, perHeight = 90 } = this.props;
            const maskOffset = ((100 - perHeight) / 100) * screenHeight;
            const { height } = event.nativeEvent.layout;
            this.extraOffset = height + headerHeight + maskOffset;
        };
        /**
         * 设置内容高度，并开始动画
         * @param event
         */
        this.onContentLayout = (event) => {
            const { height } = event.nativeEvent.layout;
            this.contentHeight = height;
        };
        /**
         * 设置子元素滚动视图ref
         * @param ref
         */
        this.getScrollRef = (ref) => {
            this.scrollRef = ref;
            this.updateChildNativeProps({ bounces: false });
        };
        /**
         * 子元素滚动事件监听
         * @param event
         */
        this.onChildViewScroll = (event) => {
            const { contentOffset } = (event === null || event === void 0 ? void 0 : event.nativeEvent) || {};
            this.scrollOffset = (contentOffset === null || contentOffset === void 0 ? void 0 : contentOffset.y) || 0;
            this.scrollOffset === 0 &&
                this.updateChildNativeProps({ bounces: false });
        };
        /**
         * 子元素非滚动视图时的手势移动监听
         * @param _
         * @param gestureState
         */
        this.onPanResponderMove = (_, gestureState) => {
            const { dy: moveYOffset } = gestureState;
            this.onFloatMove(moveYOffset);
        };
        /**
         * 手势移动后改变浮层位置
         * @param moveYOffset
         */
        this.onFloatMove = (moveYOffset) => {
            // 到顶后继续向下滑
            if (moveYOffset > 0) {
                // 此时禁止弹性效果
                this.updateChildNativeProps({ bounces: false });
                // 直接设置nativeProps
                this.setScrollNativeTranslateY(moveYOffset);
                // 通过state设置位置
                this.setState({ translateY: new Animated.Value(moveYOffset) });
            }
            this.moveYOffset = moveYOffset;
        };
        /**
         * 手势释放时的操作
         * @param event
         */
        this.onPanResponderRelease = (event) => {
            const { pageY } = event.nativeEvent;
            // 如果小于10，则终止操作
            if (pageY - this.touchStart >= 10) {
                this.onMoveEnd(this.moveYOffset);
            }
            this.touchStart = 0;
            this.moveYOffset = 0;
            this.updateChildNativeProps({ bounces: true, scrollEnabled: true });
        };
        /**
         * 移动结束后进行动画隐藏/重置
         * @param moveY
         */
        this.onMoveEnd = (moveY) => {
            const { moveDistance } = this.props;
            // 如果移动距离超过执行距离，则隐藏浮层
            if (moveY >= moveDistance) {
                this.onHide(true);
            }
            else {
                this.onShow(true);
            }
        };
        /**
         * 更新子元素弹性属性
         * @param bounces
         * @param scrollEnabled
         */
        this.updateChildNativeProps = ({ bounces = true, scrollEnabled = true }) => {
            // @ts-ignore
            this.scrollRef &&
                // @ts-ignore
                commonUtil.isFunction(this.scrollRef.setNativeProps) &&
                // @ts-ignore
                this.scrollRef.setNativeProps({ bounces, scrollEnabled });
        };
        /**
         * 展示动画
         */
        this.startShowAnimate = (isReset = false) => {
            const { showDuration, onShowAnimateFinished } = this.props;
            const { translateY, maskOpacity } = this.state;
            Animated.parallel([
                Animated.timing(maskOpacity, {
                    toValue: 1,
                    duration: showDuration,
                    useNativeDriver: true
                }),
                Animated.timing(translateY, {
                    toValue: 0,
                    duration: showDuration,
                    useNativeDriver: true
                })
            ]).start(() => {
                !isReset &&
                    commonUtil.isFunction(onShowAnimateFinished) &&
                    onShowAnimateFinished(true);
            });
        };
        /**
         * 隐藏动画
         */
        this.startHideAnimate = (isReset = false, isTerminate = false) => {
            const { hideDuration, onHideAnimateFinished } = this.props;
            const { translateY, maskOpacity } = this.state;
            const duration = isTerminate ? hideDuration * 1.5 : hideDuration;
            const hideAnimateHandler = Animated.parallel([
                Animated.timing(maskOpacity, {
                    toValue: 0,
                    duration,
                    useNativeDriver: true
                }),
                Animated.timing(translateY, {
                    toValue: this.contentHeight || screenHeight,
                    duration,
                    useNativeDriver: true
                })
            ]);
            hideAnimateHandler.start(() => {
                !isReset &&
                    commonUtil.isFunction(onHideAnimateFinished) &&
                    onHideAnimateFinished(false);
                // 如果没有调用回调的话，动画结束后执行回调
                this.hideCallback();
            });
            // 只在ios端执行提前结束操作
            !isAndroid &&
                setTimeout(() => {
                    hideAnimateHandler.stop();
                    this.hideCallback();
                }, duration * 0.84);
        };
        /**
         * 设置展示状态
         */
        this.onShow = (isReset = false) => {
            const { needAnimate } = this.props;
            this.hasCallFunc = false;
            if (needAnimate) {
                isReset
                    ? this.startShowAnimate(true)
                    : this.setState({
                        isShow: true,
                        translateY: new Animated.Value(screenHeight),
                        maskOpacity: new Animated.Value(0)
                    }, () => this.startShowAnimate());
            }
            else {
                this.setState({
                    isShow: true,
                    translateY: new Animated.Value(0),
                    maskOpacity: new Animated.Value(1)
                });
            }
        };
        /**
         * 隐藏浮层
         */
        this.onHide = (isReset = false, isTerminate = false) => {
            const { needAnimate } = this.props;
            if (needAnimate) {
                this.startHideAnimate(isReset, isTerminate);
            }
            else {
                this.setHideState();
            }
        };
        /**
         * 设置隐藏状态
         */
        this.setHideState = () => {
            const { onClose } = this.props;
            this.setState({
                isShow: false
            }, onClose);
            this.scrollOffset = 0;
        };
        // 如果组件初始化时就是展示状态，则不需要设置偏移量及透明度
        this.state = {
            isShow: props.visible,
            translateY: new Animated.Value(props.visible ? 0 : screenHeight),
            maskOpacity: new Animated.Value(props.visible ? 1 : 0)
        };
        this.scrollRef = null;
        this.contentRef = null;
        this.panResponder = this.createPanResponder();
        this.listenerHandler = null;
        this.extraOffset = 0;
    }
    componentDidMount() {
        if (isAndroid) {
            this.listenerHandler = BackHandler.addEventListener('hardwareBackPress', () => {
                const { isShow } = this.state;
                if (isShow) {
                    this.onHide();
                    return true;
                }
                return false;
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { visible } = this.props;
        const { visible: prevVisible } = prevProps;
        const { isShow } = this.state;
        const visibleChange = visible !== prevVisible;
        if (visible && visibleChange && !isShow) {
            this.onShow();
        }
        else if (!visible && visibleChange && isShow) {
            this.onHide();
        }
        // 设置左滑手势（展示时禁止，否则设置为可用）
        visibleChange && this.toggleSwipeControl(!visible);
    }
    componentWillUnmount() {
        this.listenerHandler && this.listenerHandler.remove();
    }
    render() {
        const { isShow, maskOpacity, translateY } = this.state;
        if (!isShow) {
            return null;
        }
        const contentStyle = this.getContentStyle();
        return (<Portal>
                <View style={styles.wrapper}>
                    <TouchableOpacity style={styles.maskWrapper} activeOpacity={1} onPress={() => this.onHide()}>
                        <Animated.View style={[styles.mask, { opacity: maskOpacity }]}/>
                    </TouchableOpacity>
                    <Animated.View style={[
            styles.contentWrapper,
            Object.assign(Object.assign({}, contentStyle), { transform: [{ translateY }] })
        ]} {...this.panResponder.panHandlers} ref={(ref) => {
            this.contentRef = ref;
        }} onLayout={this.onContentLayout}>
                        {this.renderHeader()}
                        {this.renderContent()}
                        {this.renderFooter()}
                    </Animated.View>
                </View>
            </Portal>);
    }
    /**
     * 渲染浮层头部
     * @private
     */
    renderHeader() {
        const { title, hasHeader, header } = this.props;
        // 如果有自定义头部，则直接展示
        if (isValidElement(header)) {
            return <View onLayout={this.onHeaderLayout}>{header}</View>;
        }
        // 是否需要展示头部
        if (!hasHeader) {
            return null;
        }
        return (<View style={styles.header} onLayout={this.onHeaderLayout}>
                {title ? (<View style={styles.headerContent}>
                        <Text style={styles.headerText}>{title}</Text>
                    </View>) : null}
                <TouchableOpacity style={styles.icon} hitSlop={{ left: 8, top: 8, right: 8, bottom: 8 }} onPress={() => this.onHide()}>
                    <Icon name="close" size={18} needScale={false}/>
                </TouchableOpacity>
            </View>);
    }
    /**
     * 渲染子元素
     * @private
     */
    renderContent() {
        const { content, children, injectScrollProps } = this.props;
        const scrollProps = {
            getScrollRef: this.getScrollRef,
            scrollEventThrottle: 16,
            bounces: false,
            onScroll: this.onChildViewScroll
        };
        // 如果需要注入scrollProps
        if (injectScrollProps) {
            // 以自定义元素优先
            if (isValidElement(content)) {
                return cloneElement(content, scrollProps);
            }
            // 只有一个子元素时才注入
            if (!Array.isArray(children)) {
                return cloneElement(children, scrollProps);
            }
            else {
                // eslint-disable-next-line no-console
                console.warn('存在多个子元素，无法准确注入scrollProps');
            }
        }
        return content || children;
    }
    /**
     * 渲染底部
     * @private
     */
    renderFooter() {
        const { footer } = this.props;
        // 只有是合法的react元素才渲染
        if (isValidElement(footer)) {
            return footer;
        }
        return null;
    }
    /**
     * 容器样式
     * @private
     */
    getContentStyle() {
        const { perHeight = 90, adaptFooter } = this.props;
        return {
            height: `${perHeight}%`,
            paddingTop: perHeight > 95 ? statusBarUtil.getStatusBarHeight() : 0,
            paddingBottom: adaptFooter ? statusBarUtil.getBottomBarHeight() : 0
        };
    }
    /**
     * 直接通过设置nativeProps实现下滑效果
     * @param translateY
     * @private
     */
    setScrollNativeTranslateY(translateY) {
        this.contentRef &&
            this.contentRef.setNativeProps({
                style: { transform: [{ translateY }] }
            });
    }
    /**
     * 动画结束回调
     * @private
     */
    hideCallback() {
        if (!this.hasCallFunc) {
            this.setHideState();
            this.hasCallFunc = true;
        }
    }
    /**
     * 创建手势
     * @private
     */
    createPanResponder() {
        // 只捕获滚动
        return PanResponder.create({
            onStartShouldSetPanResponder: () => false,
            onStartShouldSetPanResponderCapture: () => false,
            onMoveShouldSetPanResponder: (event, gestureState) => {
                const { pageY } = event.nativeEvent;
                const { dy } = gestureState;
                // 如果在头部区域进行了滚动，则立即响应浮层下滑
                if (pageY <= this.extraOffset && dy !== 0) {
                    return true;
                }
                // 安卓端需要特殊处理 - 顶部时禁止列表滚动
                if (isAndroid) {
                    const scrollEnabled = this.scrollOffset > 0 || dy < 0;
                    this.updateChildNativeProps({ scrollEnabled });
                }
                // 如果子元素的列表没有滚动到顶部，则不进行阻止
                if (this.scrollOffset > 0 || dy < 0) {
                    return false;
                }
                return dy > 0;
            },
            onMoveShouldSetPanResponderCapture: () => false,
            onPanResponderTerminationRequest: () => false,
            onShouldBlockNativeResponder: () => false,
            onPanResponderTerminate: () => {
                // 如果滑动过程中，控制权被交出，则执行关闭操作
                setTimeout(() => {
                    this.onHide(false, true);
                }, 30);
                return true;
            },
            onPanResponderGrant: (event) => {
                const { pageY } = event.nativeEvent;
                this.touchStart = pageY;
            },
            onPanResponderMove: this.onPanResponderMove,
            onPanResponderRelease: this.onPanResponderRelease
        });
    }
    /**
     * 禁止左滑返回
     * @param enable
     */
    toggleSwipeControl(enable) {
        const { swipeBackControl } = this.props;
        // eslint-disable-next-line no-undef
        swipeBackControl &&
            global.Ext &&
            global.Ext.setSwipeBackEnabled(enable);
    }
}
RNGestureFloat.defaultProps = {
    moveDistance: 150,
    showDuration: 300,
    hideDuration: isAndroid ? 400 : 300,
    perHeight: 90,
    needAnimate: true,
    injectScrollProps: false,
    hasHeader: true,
    swipeBackControl: true,
    adaptFooter: true,
    header: null,
    content: null,
    footer: null,
    headerHeight: 0
};
const styles = StyleSheet.create({
    wrapper: {
        height: '100%',
        width: '100%',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    maskWrapper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },
    mask: {
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)'
    },
    contentWrapper: {
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#FFFFFF',
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12
    },
    header: {
        height: 48,
        backgroundColor: '#FFFFFF',
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        position: 'relative'
    },
    headerContent: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    headerText: {
        fontSize: font.size.unscaled.fontSizeL,
        color: ThemeColor.text1,
        lineHeight: 48,
        paddingHorizontal: 20,
        flex: 1,
        fontWeight: 'bold',
        textAlign: 'center'
    },
    icon: {
        position: 'absolute',
        right: 12,
        top: 12
    }
});
